import React from "react";
import { Table as BaseTable } from "reactstrap";
import { useTableContext } from "../hooks";

export const Table = ({ table, ...props }) => {
  const _table = useTableContext();
  table = table ?? _table;
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    table;

  return (
    <BaseTable {...getTableProps()} {...props}>
      <thead>
        {headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => (
              <th
                {...column.getHeaderProps([
                  table.noWrapHeaders || column.noWrapHeader
                    ? {
                        className: "tw-whitespace-nowrap",
                      }
                    : {},
                  column.getSortByToggleProps(),
                ])}
              >
                {column.render("Header")}
                {column.canSort ? (
                  <span className="ml-2">
                    {column.isSorted ? (
                      column.isSortedDesc ? (
                        <span className="fa fa-sort-up" />
                      ) : (
                        <span className="fa fa-sort-down" />
                      )
                    ) : (
                      <span className="fa fa-sort" />
                    )}
                  </span>
                ) : null}
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row) => {
          prepareRow(row);

          return (
            <tr {...row.getRowProps()}>
              {row.cells.map((cell) => (
                <td
                  {...cell.getCellProps([
                    table.noWrapCells || cell.column.noWrapCell
                      ? {
                          className: "tw-whitespace-nowrap",
                        }
                      : {},
                  ])}
                >
                  {cell.render("Cell")}
                </td>
              ))}
            </tr>
          );
        })}
      </tbody>
    </BaseTable>
  );
};
